/**
Checks if the given value is null or undefined

Borrowed from lodash
https://github.com/lodash/lodash/blob/4.17.15/lodash.js#L11973
*/
export default function isNil(value: any) {
  return value === undefined || value === null
}
